import * as tslib_1 from "tslib";
import { define, element, render, html, until } from "@pru/pcef-wc-toolkit";
import { log } from "@pru/pcef-wc-toolkit/lib/utilities/log";
import { environment } from "@pru/pcef-wc-toolkit/lib/utilities/environment";
import { serviceRequest } from "@pru/pcef-wc-toolkit/lib/utilities/service-request";
import { dispatch } from "@pru/pcef-wc-toolkit/lib/utilities/dom-events";
import { ProjectionType } from "../../constants";
import "./ric-promo-banner-success";
import "./ric-promo-banner-incomplete";
import "./ric-modal-plan-select";
var RICPromoBannerEvents;
(function (RICPromoBannerEvents) {
    RICPromoBannerEvents["ServiceError"] = "ric-promo-service-error";
    RICPromoBannerEvents["OPEN_PLAN_PICKER"] = "open:ricModal:planPicker";
    RICPromoBannerEvents["CONFIRM_PLAN_PICKER"] = "confirm:ricModal:planPicker";
    RICPromoBannerEvents["CANCEL_PLAN_PICKER"] = "cancel:ricModal:planPicker";
})(RICPromoBannerEvents || (RICPromoBannerEvents = {}));
var goToNCMA = function (univlPlanId, pptTyCd) {
    window.location.href = environment.NEXT_CAPITAL_LINK + "?upid=" + univlPlanId + "&pptycd=" + pptTyCd;
};
var ɵ0 = goToNCMA;
var success = function (host, projections, eligibility) {
    log("ric-promo-banner-success nextStepsMessage", projections.nextStepsMessage);
    log("ric-promo-banner-success redirect url", environment[projections.nextStepsMessage]);
    return html(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n    <ric-promo-banner-success\n      .monthlyRetirementIncomeAmount=", "\n      .monthlyGoalAmount=", "\n      .asOfDate=", "\n      .onNextSteps=", "\n      .showBranding=", "\n      .ncmaEligible=", "\n      .ncmaProdctName=", "\n    >\n    </ric-promo-banner-success>\n  "], ["\n    <ric-promo-banner-success\n      .monthlyRetirementIncomeAmount=", "\n      .monthlyGoalAmount=", "\n      .asOfDate=", "\n      .onNextSteps=",
        "\n      .showBranding=", "\n      .ncmaEligible=", "\n      .ncmaProdctName=", "\n    >\n    </ric-promo-banner-success>\n  "])), projections.monthlyRetirementIncomeAmount, projections.monthlyGoalAmount, projections.asOfDate, function (e) {
        e.preventDefault();
        if (projections.projection === ProjectionType.ManagedAdvice) {
            if (host.univlplanid !== "" && host.ppttycd !== "") {
                log("known plan - acct summmary redirect to NCMA");
                goToNCMA(host.univlplanid, host.ppttycd);
            }
            else if (eligibility.eligiblePlans.length > 1 && host.univlplanid === "") {
                log("plan picker");
                var detail = eligibility.eligiblePlans;
                host.dispatchEvent(new CustomEvent(RICPromoBannerEvents.OPEN_PLAN_PICKER, { bubbles: true, detail: detail }));
            }
            else {
                goToNCMA(eligibility.eligiblePlans[0].univlPlanId, eligibility.eligiblePlans[0].pptTyCd);
            }
        }
        else if (projections.nextStepsMessage in environment) {
            window.location.href = environment[projections.nextStepsMessage];
        }
    }, projections.projection === ProjectionType.RIC3, projections.projection === ProjectionType.ManagedAdvice, projections.poweredBy || "");
};
var ɵ1 = success;
var incomplete = function (host, message) {
    log("ric-promo-banner-incomplete nextStepsMessage", message);
    log("ric-promo-banner-incomplete redirect url", environment[message]);
    return html(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n    <ric-promo-banner-incomplete\n      .onNextSteps=", "\n    >\n    </ric-promo-banner-incomplete>\n  "], ["\n    <ric-promo-banner-incomplete\n      .onNextSteps=",
        "\n    >\n    </ric-promo-banner-incomplete>\n  "])), function (e) {
        e.preventDefault();
        if (message && message in environment) {
            window.location.href = environment[message];
        }
    });
};
var ɵ2 = incomplete;
var error = function (host, errorMessage) {
    dispatch(host, RICPromoBannerEvents.ServiceError, {
        errorMessage: errorMessage
    });
    return html(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject([""], [""])));
};
var ɵ3 = error;
var loading = function () {
    return html(templateObject_4 || (templateObject_4 = tslib_1.__makeTemplateObject([""], [""])));
};
var ɵ4 = loading;
var suppress = function () {
    log("RIC promo banner is suppressed");
    return html(templateObject_5 || (templateObject_5 = tslib_1.__makeTemplateObject([""], [""])));
};
var ɵ5 = suppress;
var RICPromoBannerTemplate = function (_a) {
    var content = _a.content;
    return html(templateObject_7 || (templateObject_7 = tslib_1.__makeTemplateObject(["\n    ", "\n  "], ["\n    ",
        "\n  "])), html(templateObject_6 || (templateObject_6 = tslib_1.__makeTemplateObject(["\n      ", "\n    "], ["\n      ", "\n    "])), until(content, loading())));
};
var ɵ6 = RICPromoBannerTemplate;
var projectionRequest = function (projectionEndpoint) {
    return serviceRequest(projectionEndpoint, {
        method: "GET"
    });
};
var ɵ7 = projectionRequest;
var eligRequest = function (eligEndpoint) {
    return serviceRequest(eligEndpoint, {
        method: "GET"
    });
};
var ɵ8 = eligRequest;
var ɵ9 = function (host) { return projectionRequest(environment.API_BASE_URL + "/ric/v3/projections")
    .then(function (projections) { return eligRequest(environment.API_BASE_URL + "/ric/v3/eligibility").then(function (_a) {
    var eligibility = _a.responseData;
    if (eligibility.eligibleForNCManagedAdvice && host.univlplanid) {
        log("ncma and kown plan : " + host.univlplanid);
        //supress from acct summary
        if (eligibility.eligiblePlans.filter(function (eligPlan) { return eligPlan.univlPlanId === host.univlplanid; }).length === 0) {
            return suppress();
        }
    }
    return success(host, projections, eligibility);
}); })
    .catch(function (err) {
    if (err.statusCode === 422) {
        return incomplete(host, err.details ? err.details : "");
    }
    return error(host, err.message);
}); };
var RICPromoBannerElement = {
    content: ɵ9,
    univlplanid: "",
    ppttycd: "",
    render: render(RICPromoBannerTemplate)
};
/**
 * create & initialize modals
 */
var modals = [];
customElements.whenDefined("ric-promo-banner").then(function () {
    var modal = document.createElement("ric-modal-plan-select");
    modals.push(customElements.whenDefined("ric-modal-plan-select"));
    document.body.appendChild(modal);
    Promise.all(modals)
        .then(function () {
        var promoBanner = document.querySelector("ric-promo-banner");
        dispatch(promoBanner, "Modals ready");
        log("ric-promo-banner-modals initialized");
    })
        .catch(function () {
        log("ric-promo-banner-modals failed to initialize");
    });
});
define("ric-promo-banner", element(RICPromoBannerElement));
export { RICPromoBannerElement, goToNCMA, RICPromoBannerEvents };
export { ɵ0, ɵ1, ɵ2, ɵ3, ɵ4, ɵ5, ɵ6, ɵ7, ɵ8, ɵ9 };
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;
//# sourceMappingURL=ric-promo-banner.js.map